import React from 'react';
import { Search, Heart, MapPin, Plus, Book } from 'lucide-react';

interface EmptyStateProps {
  type: 'search' | 'favorites' | 'places' | 'events' | 'reviews' | 'notes';
  title?: string;
  description?: string;  // Alias for message (backward compatible)
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ type, title, description, message, action }: EmptyStateProps) {
  const icons = {
    search: Search,
    favorites: Heart,
    places: MapPin,
    events: MapPin,
    reviews: MapPin,
    notes: Book,
  };

  const defaults = {
    search: {
      title: 'Keine Orte gefunden',
      message: 'Versuche andere Suchbegriffe oder Filter.',
    },
    favorites: {
      title: 'Noch keine Lieblingsorte',
      message: 'Entdecke Dritte Orte und speichere deine Favoriten!',
    },
    places: {
      title: 'Noch keine Orte',
      message: 'Sei der Erste und schlage einen Ort vor!',
    },
    events: {
      title: 'Keine Events',
      message: 'Es wurden noch keine Events für diesen Ort gemeldet.',
    },
    reviews: {
      title: 'Keine Bewertungen',
      message: 'Sei der Erste, der diesen Ort bewertet!',
    },
    notes: {
      title: 'Noch keine Notizen',
      message: 'Besuche einen Ort und schreibe deine erste Notiz!',
    },
  };

  const Icon = icons[type];
  const displayTitle = title || defaults[type].title;
  const displayMessage = message || defaults[type].message;

  return (
    <div className="text-center py-12 px-4">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
        <Icon className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{displayTitle}</h3>
      <p className="text-gray-500 mb-6 max-w-sm mx-auto">{displayMessage}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-500 text-white rounded-lg font-medium hover:bg-indigo-600 transition-colors"
        >
          <Plus className="w-5 h-5" />
          {action.label}
        </button>
      )}
    </div>
  );
}
